var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.isShowed = !_vm.isShowed}}},[_vm._v("Subscribe")]),_vm._v(" "),(_vm.isShowed)?_c('div',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }